<template lang="pug">
  div
    .mobile-menu__user-info
      font-awesome-icon(:icon=['far', 'user-circle'])
      router-link(:to="{ name: 'login' }" v-if="!$store.getters['auth/isLoggedIn']") {{ trans('labels.frontend.footer.login_register') }}
      router-link(:to="{ name: 'account.orders' }" v-if="$store.getters['auth/isLoggedIn']") {{ $store.getters['auth/user'].full_name }}
    ul.mobile-menu__list
      li.mobile-menu__list-item(v-for="(item, key) in menu_items[0]" :key="item.id")
        a.mobile-menu__list-item-link(
          :href='item.url' :title='item.name'
          v-if="!menu_items[item.id]"
        ) {{ item.name }}
        a.mobile-menu__list-item-link(
          href='#' :title='item.name'
          :id="'menu-dropdown-' + item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          v-if="menu_items[item.id]"
        )
          .row
            .col
              span {{ item.name }}
            .col-auto.text-right
              font-awesome-icon.dropdown-menu__toggle(:icon=['far', 'angle-down'])
          ul.dropdown-menu(v-if="menu_items[item.id]" :aria-labelledby="'menu-dropdown-' + item.id")
            li
              router-link.site-header__navigation-link.text-uppercase.text-primary(to='/shop')
                strong All Categories
            li(v-for="levelOne in menu_items[item.id]")
              router-link(
                :to='levelOne.url' :title='levelOne.name' v-if=""
                v-slot="{ href, route, navigate, isActive, isExactActive }"
              )
                a.site-header__navigation-link(:href="href" @click="navigate" v-if="!isExactActive") {{ levelOne.name }}
                a.site-header__navigation-link(@click="hideMenu($event)" v-if="isExactActive") {{ levelOne.name }}
    ul.mobile-menu__list.mobile-menu__list--secondary
      li.mobile-menu__list-title {{ trans('labels.frontend.footer.menu') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'account.payment-notify', params: { slug: 'how-to-order' } }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.payment-notify') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.payment-notify') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'blog.index' }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans("menus.frontend.navigation.articles") }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans("menus.frontend.navigation.articles") }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'page', params: { slug: 'about-us' } }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.about-us') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.about-us') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'jobs' }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.join-us') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.join-us') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'distributors' }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.distributors') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.distributors') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'contact' }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.contact-us') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.contact-us') }}
    ul.mobile-menu__list.mobile-menu__list--secondary
      li.mobile-menu__list-title {{ trans('labels.frontend.footer.help') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'help.single', params: { slug: 'how-to-order' } }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.how-to-buy') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.how-to-buy') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'help.single', params: { slug: 'tracking' } }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.check-tracking') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.check-tracking') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'help.single', params: { slug: 'faqs' } }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.faqs') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.faqs') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'help.single', params: { slug: 'shipping' } }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.how-to-ship') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.how-to-ship') }}
      li.mobile-menu__list-item
        router-link(
          :to="{ name: 'help.single', params: { slug: 'how-to-claim' } }"
          v-slot="{ href, route, navigate, isActive, isExactActive }"
        )
          a.mobile-menu__list-item-link(:href="href" @click="navigate" v-if="!isExactActive") {{ trans('menus.frontend.navigation.how-to-claim') }}
          a.mobile-menu__list-item-link(@click="hideMenu($event)" v-if="isExactActive") {{ trans('menus.frontend.navigation.how-to-claim') }}
      li.mobile-menu__list-item
        a.mobile-menu__list-item-link(v-if="!$store.getters['auth/user'].locale || $store.getters['auth/user'].locale == 'th'" @click.prevent="setLocale('en')")
          img.site-header__language-switcher(src="/img/frontend/icons/flags/uk.png" alt="English Version" height="auto" width="24")
        a.mobile-menu__list-item-link(v-if="$store.getters['auth/user'].locale && $store.getters['auth/user'].locale == 'en'" @click.prevent="setLocale('th')")
          img.site-header__language-switcher(src="/img/frontend/icons/flags/thailand.png" alt="Thai Version" height="auto" width="24")
</template>

<script>
import Slideout from 'slideout';

import { RepositoryFactory } from '../../repositoryFactory';

const MenuRepository = RepositoryFactory.get('menu');

export default {
  data() {
    return {
      menu_items: [],
    };
  },
  watch: {
    $route() {
      if (this.slideout.isOpen()) {
        this.slideout.close();
      }
    },
  },
  created() {
    this.getMenu();
  },
  mounted() {
    this.$nextTick(() => {
      this.slideout = new Slideout({
        panel: document.getElementById('panel'),
        menu: document.getElementById('mobile-menu'),
        padding: 320,
        tolerance: 150,
        touch: false,
      });

      // Toggle button
      document.querySelector('#toggle-button').addEventListener('click', () => {
        this.slideout.toggle();
      });

      const fixed = document.querySelector('.site-header');
      const compareBar = document.querySelector('.compare-bar');

      this.slideout.on('translate', (translated) => {
        fixed.style.transform = `translateX(${translated}px)`;
        if (compareBar) {
          compareBar.style.transform = `translateX(${translated}px)`;
        }
      });

      this.slideout.on('beforeopen', () => {
        fixed.style.transition = 'transform 300ms ease';
        fixed.style.transform = 'translateX(320px)';
        if (compareBar) {
          compareBar.style.transition = 'transform 300ms ease';
          compareBar.style.transform = 'translateX(320px)';
        }
      });

      this.slideout.on('beforeclose', () => {
        fixed.style.transition = 'transform 300ms ease';
        fixed.style.transform = 'translateX(0px)';
        if (compareBar) {
          compareBar.style.transition = 'transform 300ms ease';
          compareBar.style.transform = 'translateX(0px)';
        }
      });

      this.slideout.on('open', () => {
        fixed.style.transition = '';
        if (compareBar) {
          compareBar.style.transition = '';
        }
      });

      this.slideout.on('close', () => {
        fixed.style.transition = '';
        if (compareBar) {
          compareBar.style.transition = '';
        }
      });
    });
  },
  methods: {
    async getMenu() {
      const { data } = await MenuRepository.get('header-menu').then((resp) => resp.data);
      this.menu_items = data.items;
    },
    setLocale(lang) {
      this.$store.dispatch('auth/setLocale', lang);
    },
    hideMenu(event) {
      event.preventDefault();
      this.slideout.close();
    }
  },
};
</script>
